import { createRoutine, bindRoutineToReduxForm } from 'redux-saga-routines';

export const createStamp = createRoutine('CREATE_STAMP');
export const createStampFormHandler = bindRoutineToReduxForm(createStamp);
export const getStamps = createRoutine('GET_STAMPS');
export const verifyStamp = createRoutine('VERIFY_STAMP');
export const disputeStamp = createRoutine('DISPUTE_STAMP');
